/**
 * 에디터(SunEditor)에 넣기 전 HTML 정리 — 운영 상품 6f705336(고도몰 이관) 상세에서 화면이 죽었다.
 * SunEditor 는 처음 열 때 이미지를 하나씩 덩어리(figure)로 바꾸는데, 최상위의 서식 줄이 아닌 요소(<center>·<font>·<b>·
 * <section>·<figure> 등) 하나에 이미지가 2개 이상 있으면 첫 이미지가 그 요소를 바꿔 끼워 두 번째 이미지 차례에
 * `parentNode.replaceChild` 가 null 이 되어 죽는다(TypeError … 'replaceChild'). 같은 요소를 <div> 로 감싸면 줄 단위로
 * 처리해 죽지 않는다 — 그런 최상위 요소만 <div> 로 감싼다(다른 HTML 은 그대로).
 */
const SAFE_TOP_TAGS = new Set(['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI', 'PRE', 'BLOCKQUOTE', 'TABLE', 'HR']);

export const wrapMultiImageTopBlocks = (html: string): string => {
  if (!html || !/<img/i.test(html) || typeof DOMParser === 'undefined') return html;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  let changed = false;
  for (const el of Array.from(doc.body.children)) {
    if (SAFE_TOP_TAGS.has(el.tagName)) continue;
    if (el.querySelectorAll('img').length < 2) continue;
    const wrap = doc.createElement('div');
    if (el.tagName === 'FIGURE') {
      // <figure> 는 SunEditor 자신의 이미지 덩어리 틀이라 감싸도 이미지가 두 번씩 생긴다 — 내용만 <div> 로 옮긴다.
      for (const attr of Array.from(el.attributes)) wrap.setAttribute(attr.name, attr.value);
      while (el.firstChild) wrap.appendChild(el.firstChild);
      el.replaceWith(wrap);
    } else {
      el.replaceWith(wrap);
      wrap.appendChild(el);
    }
    changed = true;
  }
  return changed ? doc.body.innerHTML : html;
};
